export default "__VITE_ASSET__929ce02b__"